import Swal from 'sweetalert2';
import { get_token, get_user_details } from "@/router";
import DisscussionComment from '@/components/DisscussionComment/DiscussionComment.vue';


export default {
  components: {
    DisscussionComment
  },
  props: {
    active_profile: {
      type: Object,
      default: null,
    },
  },
  data() {
    return ({
      topic_name: '',
      description: '',
      disscussion_topics: [],
      comment_modal_visible: false,
      report_data: null,
      editTopicData: {
        topic_id: null,
        title: '',
        description: ''
      },
      user_details: {},
      errors: {},
      selected_category: null,
      showDiscussionForm: true,
      showEditTopicForm: false,
      showEditTopicBody: true,
      maxLength : 150,
      expandedTopics: [],
    })
  },
  mounted() {
    this.user_details = get_user_details();
    this.fetch_discussion_topics();

  },
  methods: {

    get_personal_profile_picture(profileFiles) {
      if (!Array.isArray(profileFiles)) {
        return require('@/assets/images/user.png');
      }

      const profilePic = profileFiles.find(
        file => file.profile_file_type === 'profile_picture'
      );

      return profilePic?.file?.url || require('@/assets/images/user.png');
    },

    open_discussion_form() {
      this.showDiscussionForm = true;
    },

    cancel_edit_topic() {
      this.showEditTopicForm = false;
      this.editTopicData = { title: "", description: "", topic_id: null };
    },

    close_discussion_form() {
      this.showDiscussionForm = false;
      this.topic_name = "";
      this.description = "";
      this.errors = {};
    },
    getToken() {
      return get_token();
    },

    validate_discussion_topic() {
      this.errors = {};
      let isValid = true;
      if (!this.topic_name.trim()) {
        this.errors.topic_name = "Please select a topic.";
      }
      if (!this.description.trim()) {
        this.errors.description = "Description is required.";
        isValid = false;
      }
      return isValid;
    },
    create_discussion_topic() {
      this.description = this.$refs.quillDiscussionsEditorRef.getHTML();
      this.description = this.description.replace(/<\/?p>/g, '').trim();

      if (!this.description || this.description === '<br>' || this.description === '<br/>') {
        this.description = '';
      }
      if (!this.validate_discussion_topic()) {
        return;
      }
      const group_id_param = this.$route.params.group_id;
      const portal_id_param = this.$route.params.portal_id;

      const group_id = group_id_param ? Number(group_id_param) : null;
      const portal_id = group_id ? null : (portal_id_param ? Number(portal_id_param) : null);
      
      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_topic/`,
        data: JSON.stringify({
          title: this.topic_name,
          description: this.description,
          portal_id: portal_id,
          group_id: group_id,
          category_id: this.selected_category
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        contentType: 'application/json',
        success: (response) => {
          if (response?.status === "success" && response?.data?.id) {
            this.disscussion_topics.unshift(response.data);
            this.topic_name = '';
            this.description = '';

            this.$nextTick(() => {
              this.topic_name = '';
              this.description = '';
              if (this.$refs.quillDiscussionsEditorRef) {
                this.$refs.quillDiscussionsEditorRef.setHTML('');
              }
              this.close_discussion_form();

            });
          }
        },
        complete: () => {
        }
      });
    },

    fetch_discussion_topics() {
      const group_id_param = this.$route.params.group_id;
      const portal_id_param = this.$route.params.portal_id;

      const group_id = group_id_param ? Number(group_id_param) : null;
      const portal_id = group_id ? null : (portal_id_param ? Number(portal_id_param) : null);

      const requestData = {
        portal_id: portal_id,
        group_id: group_id
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_topics/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData),
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.disscussion_topics = response.data
            this.check_and_open_discussion_from_url();
            Swal.close()
          }

        },

        complete: () => {
          Swal.close()
        }
      });
    },
    check_and_open_discussion_from_url() {
      const topic_id = this.$route.query.topic_id;
      if (topic_id) {
        const topic = this.disscussion_topics.find(t => t.id == topic_id);
        if (topic) {
          this.display_comment_modal(topic);

          // Remove topic_id from URL so it doesn't open again on tab switch
          const query = { ...this.$route.query };
          delete query.topic_id;
          this.$router.replace({ query });
        }
      }
    },
    display_comment_modal(report_data) {
      if (this.comment_modal_visible && this.report_data?.id === report_data.id) {
        this.hide_comment();
        return;
      }
      this.report_data = report_data;
      this.comment_modal_visible = true;
    },

    edit_topic(topic) {
      this.showEditTopicForm = true;     // show the inline edit panel
      this.showEditTopicBody = true;
      this.editTopicData.topic_id = topic.id;
      this.editTopicData.title = topic.name;
      this.editTopicData.description = topic.description || '';
      this.$nextTick(() => {
        if (this.$refs.quillDiscussionsUpdateEditorRef) {
          this.$refs.quillDiscussionsUpdateEditorRef.setHTML(this.editTopicData.description);
        }
      });
    },

    save_topic_edits() {
      this.editTopicData.description = this.$refs.quillDiscussionsUpdateEditorRef.getHTML();
      this.editTopicData.description = this.editTopicData.description.replace(/<\/?p>/g, '').trim();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_topic/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          topic_id: this.editTopicData.topic_id,
          title: this.editTopicData.title,
          description: this.editTopicData.description
        }),
        success: (response) => {
          if (response?.status === "success" && response?.data) {
            const updated = response.data;

            // Update local array
            this.disscussion_topics = this.disscussion_topics.map(topic =>
              topic.id === updated.id ? updated : topic
            );

            Swal.close();
            this.showEditTopicForm = false;
            // Reset modal fields after DOM updates
            this.$nextTick(() => {
              this.editTopicData = {
                topic_id: null,
                title: "",
                description: ""
              };

              if (this.$refs.quillDiscussionsUpdateEditorRef) {
                this.$refs.quillDiscussionsUpdateEditorRef.setHTML("");
              }

              this.errors = {};
            });
          }
        }
      });
    },

    delete_topic(topic_id) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_topic/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ topic_id: topic_id }),
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.disscussion_topics = this.disscussion_topics.filter(topic => topic.id !== topic_id);
          }
        },
      });
    },
    hide_comment() {
      this.report_data = null;
      this.comment_modal_visible = false;
    },
    toggleDescription(topicId) {
      if (this.isExpanded(topicId)) {
        this.expandedTopics = this.expandedTopics.filter(id => id !== topicId);
      } else {
        this.expandedTopics.push(topicId);
      }
    },
   isExpanded(topicId) {
      return this.expandedTopics.includes(topicId);
    },
    displayedDescription(topic) {
    if (!topic.description) return '';

    // Show full description if expanded or shorter than maxLength
    if (this.isExpanded(topic.id) || topic.description.length <= this.maxLength) {
      return topic.description;
    }

    // Truncate and add ellipsis
    return topic.description.slice(0, this.maxLength) + '...';
  },

  },
}
